import { render, staticRenderFns } from "./addVehicle.vue?vue&type=template&id=f3f03c88&"
import script from "./addVehicle.vue?vue&type=script&lang=js&"
export * from "./addVehicle.vue?vue&type=script&lang=js&"
import style0 from "./addVehicle.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "addVehicle.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VSwitch } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {
  VAutocomplete,
  VBtn,
  VCard,
  VCardActions,
  VCardTitle,
  VContainer,
  VFlex,
  VForm,
  VLayout,
  VSpacer,
  VSwitch,
  VTextField,
})
